import { get, set } from "idb-keyval";
import { getKiinteistoImagesByKiinteistoId } from "../../api/api";

const imageCache = {}; // module-level in-memory cache

const azureBase = process.env.REACT_APP_AZURE_BLOB_BASE;

export async function fetchCoverImageWithCache(kiinteistoId) {
  if (!kiinteistoId) return null;

  // 1️⃣ In-memory cache
  if (imageCache[kiinteistoId]) {
    return imageCache[kiinteistoId];
  }

  // 2️⃣ IndexedDB cache
  const cachedBlob = await get(`cover-${kiinteistoId}`);
  if (cachedBlob) {
    const blobUrl = URL.createObjectURL(cachedBlob);
    imageCache[kiinteistoId] = blobUrl;
    return blobUrl;
  }

  // 3️⃣ Fetch from API
  try {
    const res = await getKiinteistoImagesByKiinteistoId(kiinteistoId, {
      category: "Kansikuva",
    });

    const coverImage = res.data?.rows?.[0];
    if (!coverImage) return null;

    const response = await fetch(
      coverImage.sasUrl || `${azureBase}/${coverImage.azure_blob_name}`
    );

    const blob = await response.blob();

    // Persist
    await set(`cover-${kiinteistoId}`, blob);

    const blobUrl = URL.createObjectURL(blob);
    imageCache[kiinteistoId] = blobUrl;

    return blobUrl;
  } catch (err) {
    console.error("Failed to fetch cover image for", kiinteistoId, err);
    return null;
  }
}
